/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2021, Zumper
 * @description   Date buttons for the DateRangeInput
 */

import React from 'react'

import { useIsDisabled } from '../helpers/useIsDisabled'
import * as style from '../style'
import { UndefinedOrDate } from '../types'
export interface CalendarDateButtonProps {
  currentDate: UndefinedOrDate
  dateButtonStyle?: any
  disableForeverFrom?: Date
  disableForeverTo?: Date
  disabledRanges?: ReadonlyArray<readonly [startDate: Date, endDate: Date]>
  setDate: (date: Date) => void
  isSelected: boolean
  isSelectedEndDate: boolean
  isSelectedStartDate: boolean
  isSelectedStartDateOnly: boolean
}

export const CalendarDateButton = ({
  currentDate,
  dateButtonStyle,
  disableForeverFrom,
  disableForeverTo,
  disabledRanges,
  setDate,
  isSelected,
  isSelectedEndDate,
  isSelectedStartDate,
  isSelectedStartDateOnly,
}: CalendarDateButtonProps) => {
  const disabled = useIsDisabled(currentDate, disableForeverFrom, disableForeverTo, disabledRanges)

  const isSelectedRange =
    isSelected && !isSelectedEndDate && !isSelectedStartDate && !isSelectedStartDateOnly

  const dateButton = currentDate ? (
    <button
      aria-label={`Date ${currentDate.getMonth() + 1}/${currentDate.getDate()}`}
      css={[
        style.dateButton,
        disabled && style.dateButtonDisabled,
        dateButtonStyle,
        isSelectedStartDateOnly && style.selectedStartDateOnlyButton,
        isSelectedStartDate && style.selectedStartDateButton,
        isSelectedEndDate && style.selectedEndDateButton,
      ]}
      data-active={isSelected}
      disabled={disabled}
      onClick={() => setDate(currentDate)}
      type="button"
    >
      {currentDate.getDate()}
      {}
    </button>
  ) : (
    <div css={[style.dateButton, style.dateButtonDisabled, dateButtonStyle]} />
  )
  const todayAtMidnight = new Date()
  todayAtMidnight.setHours(0, 0, 0, 0)

  return (
    <div
      css={[
        disabled || !currentDate ? style.dateButtonContainerDisabled : style.dateButtonContainer,
        isSelectedRange && style.selectedRangeButton,
      ]}
    >
      {dateButton}
      {currentDate?.getTime() === todayAtMidnight.getTime() ? (
        <span className="DateButton_dot" css={style.todayDot} />
      ) : null}
    </div>
  )
}
